module.exports = {
    'Landing': require('./landing'),
    'Search': require('./search'),
    'InlineSearch': require('./inline-search'),
    'Header': require('./header'),
    'PersonaDetail': require('./persona-detail'),
    'Detail': require('./detail'),
    'EmbeddedJobs': require('./embedded-jobs')
}